// src/components/MeschNavbar.js

import React from 'react';
import { Link } from 'react-router-dom';
import './MindMeschNavbar.css';

const MeschNavbar = () => {
  return (
    <nav className="mesch-navbar">
      <div className="powered-badge">
        Powered by <span>Mind Mesch</span>
      </div>

      <div className="mesch-logo">
        <Link to="/">Mind <span style={{ color: '#0078d4' }}>Mesch</span></Link>
      </div>

      <ul className="mesch-nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/publicdocs">API</Link></li>
        <li><Link to="/benefits">Benefits</Link></li>
        <li><Link to="/faq">FAQ</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/partner">Partner</Link></li>
        <li><Link to="/help">Help</Link></li>
        <li><Link to="/privacy">Privacy</Link></li>
        <li><Link to="/terms">Terms</Link></li>
        <li><Link to="/partner/login">Login</Link></li>

        <li>
          <a
            href="https://daisypal.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Live Site
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default MeschNavbar;
